(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-description"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('.floor_plan_image_button');
    const images = document.querySelectorAll('.floor_plan_image_item');
    if (!buttons.length || !images.length) return;

    const toggleFlippedState = () => {
      document.body.classList.toggle('flipped_image-indicator');
      images.forEach(img => img.classList.toggle('flipped_image'));
    };

    buttons.forEach(btn => btn.addEventListener('click', toggleFlippedState));
  });
  } catch(e) { console.error(e); }
})();

})();
